<template>
    <div class="row">

        <div class="alert alert-warning" role="alert" v-for="(alert,index) in validate" :key="index">
            <i data-feather="alert-circle"></i>
            {{alert}}
        </div>

        <div class="col-md-6 grid-margin stretch-card">
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title float-start">{{ $t('kemasan') }}</h6>
                    <button class="btn btn-success btn-icon text-white fw-bolder btn-icon-text float-end me-2" @click.prevent="addKemasan" type="button"> <i
                            class="mdi mdi-folder-plus"></i> </button>

                    <button class="btn btn-warning btn-icon text-black fw-bolder btn-icon-text float-end me-2" @click.prevent="uploadKemasan" type="button"> <i
                    class="mdi mdi-upload"></i> </button>
                </div>
                <div class="card-body">
                    <vue-good-table title="list-kemasan" :totalRows="totalRecordsKemasan" :rows="rowsKemasan"
                        :columns="columnsKemasan"
                        :pagination-options="{
                            enabled: true,
                            perPage: 5,
                            perPageDropdown: [5, 10, 100],
                        }"
                        :line-numbers="true"
                        >
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'actions'">

                                <a href="#" v-if="forms.status != 'FINISH'" title="Edit">
                                    <i class="mdi mdi-square-edit-outline" @click.prevent="editKemasan(props.row)" style="font-size:16px;color:#66d1d1;"></i>
                                </a>

                                <a href="#" v-if="forms.status != 'FINISH'" title="Delete">
                                    <i class="mdi mdi-delete-forever" @click.prevent="deleteKemasan(props.row)" style="font-size:16px;color:red;"></i>

                                </a>
                            </span>
                            <span v-else-if="props.column.field == 'jenis'">
                                {{ props.row.kodeJenisKemasan + " - " + props.row.namaJenisKemasan }}
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                    </vue-good-table>


                </div>
            </div>
        </div>
        <div class="col-md-6 grid-margin stretch-card">
            <div class="card">
                <div class="card-header">
                    <h6 class="card-title float-start">{{ $t('peti_kemas') }}</h6>
                    <button class="btn btn-success btn-icon text-white fw-bolder btn-icon-text float-end" @click.prevent="addKontainer" type="button"> <i
                            class="mdi mdi-folder-plus"></i> </button>
                            <button class="btn btn-warning btn-icon text-black fw-bolder btn-icon-text float-end me-2" @click.prevent="uploadKontainer" type="button"> <i
                    class="mdi mdi-upload"></i> </button>
                </div>
                <div class="card-body">
                    <vue-good-table title="list-peti-kemas" :totalRows="totalRecordsPetiKemas" :rows="rowsPetiKemas"
                        :columns="columnsPetiKemas"
                        :pagination-options="{
                            enabled: true,
                            perPage: 5,
                            perPageDropdown: [5, 10, 100],
                        }"
                        :line-numbers="true"
                        >
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'actions'">

                                <a href="#" v-if="forms.status != 'FINISH'" @click.prevent="editKontainer(props.row)" title="Edit">
                                    <i class="mdi mdi-square-edit-outline" style="font-size:16px;color:#66d1d1;"></i>
                                </a>

                                <a href="#" v-if="forms.status != 'FINISH'" title="Delete">
                                    <i class="mdi mdi-delete-forever" @click.prevent="deleteKontainer(props.row)" style="font-size:16px;color:red;"></i>

                                </a>
                            </span>
                            <span v-else-if="props.column.field == 'ukuranKontainer'">
                                {{ props.row.kodeUkuranKontainer + " - " + props.row.namaUkuranKontainer }}
                            </span>
                            <span v-else-if="props.column.field == 'jenisKontainer'">
                                {{ props.row.kodeJenisKontainer + " - " + props.row.namaJenisKontainer }}
                            </span>
                            <span v-else-if="props.column.field == 'tipeKontainer'">
                                {{ props.row.kodeTipeKontainer + " - " + props.row.namaTipeKontainer }}
                            </span>
                            <span v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </template>
                    </vue-good-table>


                </div>
            </div>
        </div>
        <modalKemasan :docForm="passDataKemasan" :docId="forms.document_id" @setValue="refreshData"></modalKemasan>
        <modalKotainer :docForm="passDataKontainer" :docId="forms.document_id" @setValue="refreshData"></modalKotainer>
        <modalKemasanUpload :docId="forms.document_id" @setValue="refreshData"></modalKemasanUpload>
        <modalKontainerUpload :docId="forms.document_id" @setValue="refreshData"></modalKontainerUpload>
    </div>
</template>

<script>
import modalKemasan from "@/components/exim/ceisa/barang_impor/modal/modalKemasan.vue";
import modalKemasanUpload from "@/components/exim/ceisa/barang_impor/modal/modalKemasanUpload.vue";
import modalKotainer from "@/components/exim/ceisa/barang_impor/modal/modalKontainer.vue";
import modalKontainerUpload from "@/components/exim/ceisa/barang_impor/modal/modalKontainerUpload.vue";
export default {
    name: "CeisaKemasan",
    components: {
        modalKemasan,
        modalKotainer,
        modalKemasanUpload,
        modalKontainerUpload
    },
    props: {
        propsData: { type: [Object, Array] },
        validate: { type: [Object, Array, String] }
    },
    data() {
        return {
            forms: [],
            errors: [],
            isLoading: false,
            totalRecordsKemasan: 0,
            rowsKemasan: [],

            columnsKemasan: [
                // {
                //     label: this.$t('seri'),
                //     field: 'seriKemasan',
                //     type: 'number',
                //     thClass: 'text-center',
                //     filterOptions: {
                //         customFilter: false,
                //         enabled: true, // enable filter for this column
                //         placeholder: '', // placeholder for filter input
                //         filterValue: "", // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         trigger: "enter", //only trigger on enter not on keyup
                //     },
                // },
                {
                    label: this.$t('jumlah'),
                    field: 'jumlahKemasan',
                    type: 'number',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('jenis'),
                    field: 'jenis',
                    type: 'string',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('merk'),
                    field: 'merkKemasan',
                    type: 'string',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],

            passDataKemasan: [],
            passDataKontainer: [],
            totalRecordsPetiKemas: 0,
            rowsPetiKemas: [],

            columnsPetiKemas: [
                // {
                //     label: this.$t('seri'),
                //     field: 'seriKontainer',
                //     type: 'number',
                //     thClass: 'text-center',
                //     filterOptions: {
                //         customFilter: false,
                //         enabled: true, // enable filter for this column
                //         placeholder: '', // placeholder for filter input
                //         filterValue: "", // initial populated value for this filter
                //         filterDropdownItems: [], // dropdown (with selected values) instead of text input
                //         trigger: "enter", //only trigger on enter not on keyup
                //     },
                // },
                {
                    label: this.$t('nomorNya'),
                    field: 'nomorKontainer',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('ukuran'),
                    field: 'ukuranKontainer',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('jenis'),
                    field: 'jenisKontainer',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t('type'),
                    field: 'tipeKontainer',
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },
            ],
        }
    },
    methods: {
        editKemasan(row) {
            this.passDataKemasan = row;
            this.$modal.show('modalKemasan');
        },
        deleteKemasan(row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-6-delete-kemasan/"+this.forms.document_id+"/" + row.document_kemasan_id;
                    this.$http
                        .delete(baseURI, { timeout: 10000 })
                        .then((response) => {
                            this.isLoading = false;
                            if (response.data.status === 200) {
                                this.success("Success");
                                this.$emit("updateData");
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.isLoading = false;

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },
        addKemasan() {
            this.passDataKemasan = {
                seriKemasan: this.rowsKemasan.length + 1,
                document_id: this.forms.document_id,
                jumlahKemasan: "",
                kodeJenisKemasan: "",
                namaJenisKemasan: "",
                merkKemasan: "",
            };
            this.$modal.show('modalKemasan');
        },
        uploadKemasan(){
            this.$modal.show('modalKemasanUpload');
        },
        uploadKontainer(){
            this.$modal.show('modalKontainerUpload');
        },
        addKontainer() {
            this.passDataKontainer = {
                seriKontainer: this.rowsPetiKemas.length + 1,
                document_id: this.forms.document_id,
                nomorKontainer: "",
                kodeJenisKontainer: "",
                namaJenisKontainer: "",
                kodeTipeKontainer: "",
                namaTipeKontainer: "",
                kodeUkuranKontainer: "",
                namaUkuranKontainer: "",
            };
            this.$modal.show('modalKontainer');
            
        },
        editKontainer(row) {
            this.passDataKontainer = row;
            this.$modal.show('modalKontainer');
        },
        deleteKontainer(row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-6-delete-peti-kemas/"+this.forms.document_id+"/"+ row.document_kontainer_id;
                    this.$http
                        .delete(baseURI, { timeout: 10000 })
                        .then((response) => {
                            this.isLoading = false;
                            if (response.data.status === 200) {
                                this.success("Success");
                                this.$emit("updateData");
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.isLoading = false;

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },
        refreshData() {
            this.success("Berhasil");
            this.$emit("updateData");
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
        reAssignValue() {
            this.rowsKemasan = this.forms.kemasan;
            this.rowsPetiKemas = this.forms.kontainer;

        },
    },
    created() {

    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            this.reAssignValue();
        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
}
</script>

<style></style>